import { useState, type ReactNode } from 'react';
import { Eye, EyeOff } from '../../ui/icons';

/** Email/password field with a show/hide toggle. */
export function PasswordField({
  label = 'Password',
  value,
  onChange,
  autoComplete,
  placeholder = '••••••••',
  trailingLabel
}: {
  label?: string;
  value: string;
  onChange: (v: string) => void;
  autoComplete?: string;
  placeholder?: string;
  trailingLabel?: ReactNode;
}) {
  const [show, setShow] = useState(false);
  return (
    <div>
      {trailingLabel ? (
        <div className="mb-[7px] flex items-center justify-between">
          <span className="text-[11px] font-bold uppercase tracking-eyebrow text-ink2">{label}</span>
          {trailingLabel}
        </div>
      ) : null}
      <label className="block">
        {!trailingLabel && (
          <span className="mb-[7px] block text-[11px] font-bold uppercase tracking-eyebrow text-ink2">
            {label}
          </span>
        )}
        <div className="flex items-center gap-2 rounded-2xl border border-black/5 bg-card px-4 shadow-tile transition-colors focus-within:border-accent-ink/40">
          <input
            type={show ? 'text' : 'password'}
            value={value}
            onChange={(e) => onChange(e.target.value)}
            placeholder={placeholder}
            autoComplete={autoComplete}
            className="w-full bg-transparent py-[14px] text-[15px] font-medium text-ink outline-none placeholder:text-ink3"
          />
          <button
            type="button"
            onClick={() => setShow((s) => !s)}
            className="tap -mr-2 grid h-8 w-8 place-items-center text-ink3 active:opacity-60"
            aria-label={show ? 'Hide password' : 'Show password'}
          >
            {show ? <EyeOff width={18} height={18} /> : <Eye width={18} height={18} />}
          </button>
        </div>
      </label>
    </div>
  );
}
